import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Tooltip } from '@lightspeed/flame/Tooltip';

export const LinkButton = styled(Button)`
  display: inline-block;
  color: white !important;
  max-height: 1.15rem;
  padding: 0.375rem 1.125rem;
  width: fit-content;
  margin-left: 1.125rem;
  @media only screen and (max-width: 1260px) {
    margin-top: 1rem;
    margin-left: 0;
  }
`;

export const StatusPillBox = styled(Box)`
  margin: 0;
  @media only screen and (max-width: 1080px) {
    margin-top: 6px;
  }
  @media (min-width: 860px) and (max-width: 1020px) {
    margin-top: 0;
  }
  @media only screen and (max-width: 860px) {
    margin-top: 6px;
  }
`;

export const TitleFlexContainer = styled(Flex)`
  flex-direction: row;
  @media (min-width: 1020px) and (max-width: 1080px) {
    flex-direction: column;
  }
  @media (min-width: 860px) and (max-width: 1020px) {
    flex-direction: row;
  }
  @media only screen and (max-width: 860px) {
    flex-direction: column;
  }
`;

export const BodyFlexContainer = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;

  @media only screen and (max-width: 1260px) {
    flex-direction: column;
  }
`;

export const StyledToolTip = styled(Tooltip)`
  max-width: 264px;
  padding: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  z-index: 100;
`;
